export const environment = {
    version: '5.0.0-beta.1 - 13/07/2026',                           //VERSION
    production: false,
    apiUrl: 'https://staging.emetro-api.com'    //STAGE API Updates
};